import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { PhysicalPrepaidCardBalanceDetailResponse } from '@/repositories/generated';

const responses: PhysicalPrepaidCardBalanceDetailResponse[] = [
  {
    physicalPrepaidCardNumber: '0000000000000001',
    pointBalance: {
      basicPoint: {
        balanceExpiresAt: [
          {
            balance: 0,
            expiresAt: '2024-08-19T04:41:57.923Z',
          },
        ],
        balanceTotal: 0,
      },
      bonusPoint: {
        balanceExpiresAt: [
          {
            balance: 0,
            expiresAt: '2024-08-19T04:41:57.923Z',
          },
        ],
        balanceTotal: 0,
      },
      pointTotal: 0,
    },
    scheduleBalance: {
      basicPoint: {
        balanceTotal: 0,
        grantSchedule: [
          {
            amount: 0,
            scheduleDateTime: '2024-08-19T04:41:57.923Z',
          },
        ],
      },
      bonusPoint: {
        balanceTotal: 0,
        grantSchedule: [
          {
            amount: 0,
            scheduleDateTime: '2024-08-19T04:41:57.923Z',
          },
        ],
      },
      bonusValue: {
        balanceTotal: 0,
        grantSchedule: [
          {
            amount: 0,
            scheduleDateTime: '2024-08-19T04:41:57.923Z',
          },
        ],
      },
    },
    valueBalance: {
      bonusValue: {
        balanceExpiresAt: [
          {
            balance: 0,
            expiresAt: '2024-08-19T04:41:57.923Z',
          },
        ],
        balanceTotal: 0,
      },
      prepaidValue: {
        balanceExpiresAt: [
          {
            balance: 0,
            expiresAt: '2024-08-19T04:41:57.923Z',
          },
        ],
        balanceTotal: 0,
      },
      valueTotal: 0,
    },
  },
  {
    physicalPrepaidCardNumber: '0000000000000002',
    pointBalance: {
      basicPoint: {
        balanceExpiresAt: undefined,
        balanceTotal: 400,
      },
      bonusPoint: {
        balanceExpiresAt: undefined,
        balanceTotal: 600,
      },
      pointTotal: 1000,
    },
    scheduleBalance: {
      basicPoint: {
        balanceTotal: 200,
        grantSchedule: undefined,
      },
      bonusPoint: {
        balanceTotal: 300,
        grantSchedule: undefined,
      },
      bonusValue: {
        balanceTotal: 1000,
        grantSchedule: [
          {
            amount: 0,
            scheduleDateTime: '2024-08-19T04:41:57.923Z',
          },
        ],
      },
    },
    valueBalance: {
      bonusValue: {
        balanceExpiresAt: [
          {
            balance: 1000,
            expiresAt: undefined,
          },
          {
            balance: 1000,
            expiresAt: '9999-12-31T00:00:00',
          },
        ],
        balanceTotal: 2000,
      },
      prepaidValue: {
        balanceExpiresAt: [
          {
            balance: 3000,
            expiresAt: '2024-08-19T04:41:57.923Z',
          },
        ],
        balanceTotal: 3000,
      },
      valueTotal: 5000,
    },
  },
  {
    physicalPrepaidCardNumber: '0000000000000003',
    pointBalance: {
      basicPoint: {
        balanceExpiresAt: [
          {
            balance: 100,
            expiresAt: '2024-08-19T04:41:57.923Z',
          },
          {
            balance: 990,
            expiresAt: '2024-08-31T04:41:57.923Z',
          },
        ],
        balanceTotal: 1090,
      },
      bonusPoint: {
        balanceExpiresAt: [
          {
            balance: 100,
            expiresAt: '2024-08-19T04:41:57.923Z',
          },
          {
            balance: 200,
            expiresAt: '2024-08-29T04:41:57.923Z',
          },
        ],
        balanceTotal: 300,
      },
      pointTotal: 1390,
    },
    scheduleBalance: {
      basicPoint: {
        balanceTotal: 1100,
        grantSchedule: [
          {
            amount: 500,
            scheduleDateTime: '2024-08-19T04:41:57.923Z',
          },
          {
            amount: 600,
            scheduleDateTime: '2024-08-19T04:41:57.923Z',
          },
        ],
      },
      bonusPoint: {
        balanceTotal: 1200,
        grantSchedule: [
          {
            amount: 1111,
            scheduleDateTime: '2024-08-19T04:41:57.923Z',
          },
          {
            amount: 99,
            scheduleDateTime: '2024-08-19T04:41:57.923Z',
          },
        ],
      },
      bonusValue: {
        balanceTotal: 1300,
        grantSchedule: [
          {
            amount: 600,
            scheduleDateTime: '2024-08-19T04:41:57.923Z',
          },
          {
            amount: 700,
            scheduleDateTime: '2024-08-29T04:41:57.923Z',
          },
        ],
      },
    },
    valueBalance: {
      bonusValue: {
        balanceExpiresAt: [
          {
            balance: 0,
            expiresAt: '2024-08-19T04:41:57.923Z',
          },
          {
            balance: 100,
            expiresAt: '2024-08-29T04:41:57.923Z',
          },
        ],
        balanceTotal: 100,
      },
      prepaidValue: {
        balanceExpiresAt: [
          {
            balance: 100,
            expiresAt: '2024-08-19T04:41:57.923Z',
          },
          {
            balance: 200,
            expiresAt: '2024-08-29T04:41:57.923Z',
          },
        ],
        balanceTotal: 300,
      },
      valueTotal: 400,
    },
  },
];

export const physicalPrepaidCardBalance = http.get(
  createMockEndpoint('/physical_prepaid_card/:cardNumber/balance'),
  async ({ params }) => {
    await delay(500);
    return HttpResponse.json(responses.find((response) => response.physicalPrepaidCardNumber === params.cardNumber), { status: 200 });
  },
);
